import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import Select from "react-select";
import Swal from "sweetalert2";
import { gruposOpciones, hotelesOpciones, impuestosOpciones } from "../../../hook/Arreglos";

import { useDispatch } from "react-redux";
import { EditarArticu } from "../../../store/Articulos/thunkArticulos";

export const EditarArticulo = ({ open, handleClose, fetchArticulos, type , Articulo }) => {

    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        nombre_articulo: "",
        desc_articulo: "",
        hotelesSeleccionados: [],
        precio_general: "",
        precios_especificos: {},
        trece_articulo: "0",
        diez_articulo: "0",
        grupo_articulo: "",
        id_articulo: "",
    });


    useEffect(() => {
        if (Articulo && Object.keys(Articulo).length > 0) {
            setFormData({
                ...formData,
                nombre_articulo: Articulo.nombre_articulo || "",
                desc_articulo: Articulo.desc_articulo || "",
                grupo_articulo: Articulo.grupo_articulo || "",
                precio_general: Articulo.precio_art || "",
                trece_articulo: parseFloat(Articulo.trece_articulo),
                diez_articulo: parseFloat(Articulo.diez_articulo) ,
                hotelesSeleccionados: Articulo.hotelesSeleccionados || [],
                precios_especificos: Articulo.precios_especificos || {},
                id_articulo: Articulo.id_articulo || "",
            });
        }
    }, [Articulo]);

    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Quitar error si el campo se llena
        if (value !== "") {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
        }
    };

    const handleSelectChange = (name, option) => {
        setFormData({ ...formData, [name]: option ? option.value : "" });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
    };

    const handleMultiSelectChange = (name, selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
        setFormData({ ...formData, [name]: values });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
    };

    const handlePriceChange = (hotel, value) => {
        setFormData((prevData) => ({
            ...prevData,
            precios_especificos: {
                ...prevData.precios_especificos,
                [hotel]: value,
            },
        }));

        // Quitar error si el campo de precio para el hotel se llena
        if (value !== "") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [`precio_${hotel}`]: false,
            }));
        }
    };
    const validateForm = () => {
        const newErrors = {};

        // Validar campos obligatorios excepto precios específicos
        Object.keys(formData).forEach((key) => {
            if (formData[key] === "" && key !== "precios_especificos" && key !== "hotelesSeleccionados") {
                newErrors[key] = true;
            }
        });

        // Validar que al menos un hotel esté seleccionado
        if (formData.hotelesSeleccionados.length === 0) {
            newErrors["hotelesSeleccionados"] = true;
        }

        // Validar precios específicos para hoteles seleccionados
        formData.hotelesSeleccionados.forEach((hotel) => {
            if (!formData.precios_especificos[hotel] || formData.precios_especificos[hotel] === "") {
                newErrors[`precio_${hotel}`] = true;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas Editar el artículo con la información proporcionada?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Editar",
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Mostrar preloader
                Swal.fire({
                    title: "Editando artículo",
                    text: "Por favor espere...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                await dispatch(EditarArticu(formData));

                // Mensaje de éxito y cierre del modal
                Swal.fire({
                    icon: "success",
                    title: "Artículo Editado",
                    text: "El artículo ha sido Editado exitosamente.",
                    confirmButtonText: "Aceptar",
                }).then(() => {
                    if (type === "lista") {
                        fetchArticulos(1);
                    }
                });
            }
        });

       handleClose();
    };

    const getInputClass = (field) => (errors[field] ? "form-control is-invalid" : "form-control");

    return (
        <>
            <style>
                {`
                    .is-invalid {
                        border: 2px solid red;
                    }
                    .react-select-container .is-invalid .react-select__control {
                        border-color: red !important;
                    }
                `}
            </style>

            <Modal open={open} onClose={handleClose} className="modal fade show" style={{ display: "block" }}>
                <div className="modal-dialog" style={{ maxWidth: "60%", margin: "1.75rem auto" }}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <h5 style={{ fontSize: window.innerWidth < 600 ? "16px" : "28px" }}>Editar Articulo : {Articulo.nombre_articulo}</h5>

                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="mb-3">
                                        <label>Nombre del Artículo</label>
                                        <input
                                            type="text"
                                            name="nombre_articulo"
                                            className={getInputClass("nombre_articulo")}
                                            value={formData.nombre_articulo}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label>Grupo del Artículo</label>
                                        <Select
                                            options={gruposOpciones}
                                            placeholder="Seleccione un grupo"
                                            className={errors.grupo_articulo ? "is-invalid react-select-container" : "react-select-container"}
                                            value={gruposOpciones.find((opt) => opt.value === formData.grupo_articulo)}
                                            onChange={(option) => handleSelectChange("grupo_articulo", option)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label>Precio General</label>
                                        <input
                                            type="number"
                                            name="precio_general"
                                            className={getInputClass("precio_general")}
                                            value={formData.precio_general}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label>Seleccione los Hoteles</label>
                                        <Select
                                            isMulti
                                            options={hotelesOpciones}
                                            placeholder="Seleccione los hoteles"
                                            className={errors.hotelesSeleccionados ? "is-invalid react-select-container" : "react-select-container"}
                                            value={hotelesOpciones.filter((opt) => formData.hotelesSeleccionados.includes(opt.value))}
                                            onChange={(options) => handleMultiSelectChange("hotelesSeleccionados", options)}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    {formData.hotelesSeleccionados.map((hotel) => {
                                        // Buscar el label del hotel usando el value
                                        const hotelLabel = hotelesOpciones.find((opt) => opt.value === hotel)?.label || hotel;

                                        return (
                                            <div className="mb-3" key={hotel}>
                                                <label>Precio para {hotelLabel}</label>
                                                <input
                                                    type="number"
                                                    className={getInputClass(`precio_${hotel}`)}
                                                    value={formData.precios_especificos[hotel] || ""}
                                                    onChange={(e) => handlePriceChange(hotel, e.target.value)}
                                                />
                                            </div>
                                        );
                                    })}

                                    <div className="mb-3">
                                        <label>Seleccione el 13%</label>
                                        <Select
                                            options={impuestosOpciones}
                                            placeholder="Seleccione"
                                            className={errors.trece_articulo ? "is-invalid react-select-container" : "react-select-container"}
                                            value={impuestosOpciones.find((opt) => opt.value === formData.trece_articulo)}
                                            onChange={(option) => handleSelectChange("trece_articulo", option)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label>Seleccione el 10%</label>
                                        <Select
                                            options={impuestosOpciones}
                                            placeholder="Seleccione"
                                            className={errors.diez_articulo ? "is-invalid react-select-container" : "react-select-container"}
                                            value={impuestosOpciones.find((opt) => opt.value === formData.diez_articulo)}
                                            onChange={(option) => handleSelectChange("diez_articulo", option)}
                                        />
                                    </div>
                                </div>

                                <div className="mb-12">
                                    <label>Descripción del Artículo</label>
                                    <textarea
                                        name="desc_articulo"
                                        className={getInputClass("desc_articulo")}
                                        rows="15"
                                        value={formData.desc_articulo}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <br />
                            <button type="button" onClick={handleSubmit} className="btn btn-dark">
                                Guardar artículo
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
